import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { uploadFilesThunk } from '../asyncThunks/configuration'
import { ConfigurationFormValues, MyFile } from '../types/configuration'
import { configurationInitialState } from '../initialState/configuration'

const configurationSlice = createSlice({
  name: 'configuration',
  initialState: configurationInitialState,
  reducers: {
    setFormData(state, action: PayloadAction<ConfigurationFormValues>) {
      state.formData = action.payload
    },
    clearFiles(state) {
      state.files = []
    },
    setUploadedFiles(state, action: PayloadAction<MyFile[]>) {
      state.files = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadFilesThunk.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        uploadFilesThunk.fulfilled,
        (state, action: PayloadAction<MyFile[]>) => {
          state.loading = false
          state.files = [...state.files, ...action.payload]
        }
      )
      .addCase(uploadFilesThunk.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

export const { setFormData, clearFiles, setUploadedFiles } =
  configurationSlice.actions
export default configurationSlice.reducer
